import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function SpecialistenInElektronica() {
  return <section data-section-id="224810" id="the-pulse-of-the-studio" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          
          {}
          <div className="relative order-2 md:order-1 group">
            <div className="relative z-10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/pulsewave_studio_exterior.png" alt="PulseWave Studios exterior in the creative district" className="w-full h-auto rounded-3xl border border-border shadow-2xl object-cover aspect-square md:aspect-[4/3] transition-transform duration-500 group-hover:scale-[1.02] grayscale hover:grayscale-0" />
            </div>
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] bg-primary/10 rounded-full blur-3xl -z-0 opacity-30"></div>
          </div>

          {}
          <div className="flex flex-col justify-center space-y-6 order-1 md:order-2">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-primary tracking-tighter">
              The Pulse of the Studio
            </h2>
            
            <div className="space-y-4 font-default text-foreground/80 text-lg leading-relaxed">
              <p>
                Born in the heart of the city's vibrant creative district, PulseWave Studios began as a vision to bridge the gap between raw artistic energy and high-fidelity precision. Our walls were built to capture the resonance of every frequency, creating a sanctuary where sound isn't just recorded—it's sculpted.
              </p>
              <p>
                From our humble beginnings as a boutique mixing suite to becoming a cornerstone of the local music scene, we've remained dedicated to the pulse of the artist. We combine cutting-edge digital workflows with the warmth of vintage analog soul to help you find your unique sonic signature.
              </p>
            </div>

            <div className="pt-6">
              <Button asChild variant="default" size="lg" className="font-default font-semibold rounded-full shadow-lg shadow-primary/20">
                <Link to="/TheSpacePage">
                  Explore the Space <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}